import { Help, QuestionMark } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FaExclamation } from "react-icons/fa6";

const Subtitle = (props: { children: React.ReactNode, help?: string }) => {
  return <h2 className="mb-0 text-neutral/90 text-l font-light">
    {props.children}
    {props.help &&
      <a href={props.help} target="_blank" rel="noreferrer" title="Help">
        <IconButton>
          <QuestionMark />
        </IconButton>
      </a>
    }
  </h2>;
}

export default Subtitle;